<mg-table [collectionComponent]="this" matSort stickyHeaders>

	<ng-container matColumnDef="pakbon">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Pakbon </th>
        <td mat-cell *matCellDef="let row"> {{row.pakbon?.pakbonnummer}} </td>
    </ng-container>

	<ng-container matColumnDef="projectregel">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Bonnr. </th>
        <td mat-cell *matCellDef="let row"> {{row.projectregel.id}} </td>
    </ng-container>

    <ng-container matColumnDef="soort">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Soort </th>
        <td mat-cell *matCellDef="let row"> {{row.projectregel.instrument.soort}} </td>
    </ng-container>

    <ng-container matColumnDef="merk">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Merk </th>
        <td mat-cell *matCellDef="let row"> {{row.projectregel.instrument.merk}} </td>
    </ng-container>

    <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
        <td mat-cell *matCellDef="let row"> {{row.projectregel.instrument.type}} </td>
    </ng-container>

    <ng-container matColumnDef="kalibratiePrijs">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Kalibratie Prijs </th>
        <td mat-cell *matCellDef="let row"> € {{showKalibratiePrijs(row.projectregel.kalibratiePrijs?.toFixed(2), row.projectregel.prijsBlock, row.projectregel.prijsKalibratie?.toFixed(2))}}</td>
    </ng-container>

    <ng-container matColumnDef="prijsArtikelen">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Prijs Artikelen </th>
        <td mat-cell *matCellDef="let row"> € {{row.projectregel.prijsArtikelen?.toFixed(2)}}  </td>
    </ng-container>

    <ng-container matColumnDef="prijsBlock">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Prijs Block </th>
        <td mat-cell *matCellDef="let row"> {{row.projectregel.prijsBlock }}  </td>
    </ng-container>

    <ng-container matColumnDef="prijsKalibratie">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Prijs Kalibratie </th>
        <td mat-cell *matCellDef="let row"> € {{row.projectregel.prijsKalibratie?.toFixed(2)}}  </td>
    </ng-container>


</mg-table>
